import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/feature/LanguageSwitcher';
import CaseBlock from '../components/CaseBlock';

export default function CaseStudyCashlessPage() {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'B2B決済 導入事例 | 株式会社LIKES - 福岡市 キャッシュレス決済 美容商社 導入支援';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        '株式会社LIKESのB2B決済導入事例。大手美容商社（ディーラー）様のキャッシュレス決済システム導入・定着・実行支援プロジェクト。課題・解決アプローチ・成果を詳しくご紹介します。福岡市のB2B決済導入支援実績。',
      );
    }
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schemas = [
      {
        id: 'schema-webpage-cs-cashless',
        data: { '@context': 'https://schema.org', '@type': 'WebPage', url: `${siteUrl}/case-study/cashless`, name: 'B2B決済 導入事例 | 株式会社LIKES', inLanguage: 'ja' },
      },
      {
        id: 'schema-breadcrumb-cs-cashless',
        data: {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` },
            { '@type': 'ListItem', position: 2, name: '導入事例', item: `${siteUrl}/case-study` },
            { '@type': 'ListItem', position: 3, name: 'B2B決済', item: `${siteUrl}/case-study/cashless` },
          ],
        },
      },
    ];
    schemas.forEach(({ id, data }) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(data);
      script.id = id;
      document.head.appendChild(script);
    });
    return () => {
      schemas.forEach(({ id }) => {
        document.getElementById(id)?.remove();
      });
    };
  }, []);

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const case4Challenges = [
    { titleKey: 'page.caseStudy.case4.challenge.1.title', descKey: 'page.caseStudy.case4.challenge.1.desc' },
    { titleKey: 'page.caseStudy.case4.challenge.2.title', descKey: 'page.caseStudy.case4.challenge.2.desc' },
  ];

  const case4Approaches = [
    { step: '01', titleKey: 'page.caseStudy.case4.approach.1.title', descKey: 'page.caseStudy.case4.approach.1.desc' },
    { step: '02', titleKey: 'page.caseStudy.case4.approach.2.title', descKey: 'page.caseStudy.case4.approach.2.desc' },
    { step: '03', titleKey: 'page.caseStudy.case4.approach.3.title', descKey: 'page.caseStudy.case4.approach.3.desc' },
  ];

  const case4Results = [
    { titleKey: 'page.caseStudy.case4.results.1.title', descKey: 'page.caseStudy.case4.results.1.desc' },
    { titleKey: 'page.caseStudy.case4.results.2.title', descKey: 'page.caseStudy.case4.results.2.desc' },
  ];

  const case4Kpis = [
    { valueKey: 'page.caseStudy.case4.results.kpi1.value', labelKey: 'page.caseStudy.case4.results.kpi1.label' },
    { valueKey: 'page.caseStudy.case4.results.kpi2.value', labelKey: 'page.caseStudy.case4.results.kpi2.label' },
    { valueKey: 'page.caseStudy.case4.results.kpi3.value', labelKey: 'page.caseStudy.case4.results.kpi3.label' },
  ];

  const case5Challenges = [
    { titleKey: 'page.caseStudy.case5.challenge.1.title', descKey: 'page.caseStudy.case5.challenge.1.desc' },
    { titleKey: 'page.caseStudy.case5.challenge.2.title', descKey: 'page.caseStudy.case5.challenge.2.desc' },
  ];

  const case5Approaches = [
    { step: '01', titleKey: 'page.caseStudy.case5.approach.1.title', descKey: 'page.caseStudy.case5.approach.1.desc' },
    { step: '02', titleKey: 'page.caseStudy.case5.approach.2.title', descKey: 'page.caseStudy.case5.approach.2.desc' },
    { step: '03', titleKey: 'page.caseStudy.case5.approach.3.title', descKey: 'page.caseStudy.case5.approach.3.desc' },
  ];

  const case5Results = [
    { titleKey: 'page.caseStudy.case5.results.1.title', descKey: 'page.caseStudy.case5.results.1.desc' },
    { titleKey: 'page.caseStudy.case5.results.2.title', descKey: 'page.caseStudy.case5.results.2.desc' },
  ];

  const case5Kpis = [
    { valueKey: 'page.caseStudy.case5.results.kpi1.value', labelKey: 'page.caseStudy.case5.results.kpi1.label' },
    { valueKey: 'page.caseStudy.case5.results.kpi2.value', labelKey: 'page.caseStudy.case5.results.kpi2.label' },
    { valueKey: 'page.caseStudy.case5.results.kpi3.value', labelKey: 'page.caseStudy.case5.results.kpi3.label' },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" className="flex flex-col leading-none cursor-pointer">
            <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.18em' }} className="text-[#255485] font-bold text-xl sm:text-2xl tracking-widest uppercase">LIKES</span>
            <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.22em' }} className="text-[#255485]/70 text-[8px] sm:text-[9px] font-medium tracking-[0.22em] uppercase mt-0.5">Co, Ltd</span>
          </Link>
          <nav className="hidden lg:flex items-center gap-6">
            <Link to="/#vision" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer">{t('nav.vision')}</Link>
            <Link to="/#services" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer">{t('nav.services')}</Link>
            <Link to="/case-study" className="text-[#255485] font-semibold text-sm whitespace-nowrap cursor-pointer border-b-2 border-[#255485] pb-0.5">{t('nav.caseStudy')}</Link>
            <Link to="/#csr" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer">{t('nav.csr')}</Link>
            <Link to="/#company" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer">{t('nav.company')}</Link>
            <LanguageSwitcher />
            <button onClick={scrollToContact} className="bg-[#255485] text-white px-6 py-2.5 rounded-lg hover:bg-[#1d4166] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer">{t('nav.contact')}</button>
          </nav>
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer">
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
        <div className={`lg:hidden bg-white border-t border-gray-200 transition-all duration-300 overflow-hidden ${mobileMenuOpen ? 'max-h-screen' : 'max-h-0'}`}>
          <nav className="px-4 py-4 space-y-2">
            <div className="flex items-center px-4 py-2 gap-3"><span className="text-xs text-gray-500">Language</span><LanguageSwitcher /></div>
            <Link to="/#vision" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#255485] rounded-lg text-sm font-medium cursor-pointer">{t('nav.vision')}</Link>
            <Link to="/#services" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#255485] rounded-lg text-sm font-medium cursor-pointer">{t('nav.services')}</Link>
            <Link to="/case-study" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-3 text-[#255485] bg-[#255485]/5 rounded-lg text-sm font-semibold cursor-pointer">{t('nav.caseStudy')}</Link>
            <Link to="/#csr" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#255485] rounded-lg text-sm font-medium cursor-pointer">{t('nav.csr')}</Link>
            <Link to="/#company" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#255485] rounded-lg text-sm font-medium cursor-pointer">{t('nav.company')}</Link>
            <button onClick={() => { setMobileMenuOpen(false); scrollToContact(); }} className="block w-full text-left px-4 py-3 bg-[#255485] text-white hover:bg-[#1d4166] rounded-lg text-sm font-medium cursor-pointer">{t('nav.contact')}</button>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="relative pt-16 sm:pt-20 overflow-hidden">
        <div className="relative h-64 sm:h-80 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/39b8b917fed6347d8339e1b6a9975a7c.jpg"
            alt="B2B決済 導入事例"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
          <div className="absolute inset-0 flex flex-col items-start justify-end pb-10 sm:pb-14 max-w-7xl mx-auto px-4 sm:px-6 w-full">
            <div className="flex items-center gap-2 mb-3">
              <span className="bg-white/20 text-white text-xs font-medium px-3 py-1 rounded-full backdrop-blur-sm">{t('page.caseStudy.cashless.hero.badge')}</span>
              <span className="bg-[#255485]/80 text-white text-xs font-medium px-3 py-1 rounded-full">{t('page.caseStudy.cashless.hero.category')}</span>
            </div>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-serif text-white leading-snug max-w-3xl" style={{ whiteSpace: 'pre-line' }}>{t('page.caseStudy.cashless.hero.title')}</h1>
          </div>
        </div>
      </section>

      {/* Category Tab Switcher */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex justify-center gap-3">
          <Link
            to="/case-study"
            className="px-5 py-2 rounded-full text-sm font-medium text-gray-500 hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('page.caseStudy.tab.consulting')}
          </Link>
          <Link
            to="/case-study/cashless"
            className="px-5 py-2 rounded-full text-sm font-semibold bg-[#255485] text-white whitespace-nowrap cursor-pointer"
          >
            {t('page.caseStudy.tab.cashless')}
          </Link>
        </div>
      </div>

      {/* Case 4: Beauty Dealer */}
      <CaseBlock
        eyebrowKey="page.caseStudy.case4.eyebrow"
        titleKey="page.caseStudy.case4.title"
        subtitleKey="page.caseStudy.case4.subtitle"
        bgColor="#F7F5F2"
        challenges={case4Challenges}
        approaches={case4Approaches}
        results={case4Results}
        kpis={case4Kpis}
      />

      {/* Case 5: Medical Industry Association */}
      <CaseBlock
        eyebrowKey="page.caseStudy.case5.eyebrow"
        titleKey="page.caseStudy.case5.title"
        subtitleKey="page.caseStudy.case5.subtitle"
        bgColor="#EEF3F8"
        challenges={case5Challenges}
        approaches={case5Approaches}
        results={case5Results}
        kpis={case5Kpis}
      />

      {/* CTA */}
      <section className="py-16 sm:py-20 bg-[#255485]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl font-serif text-white mb-4" style={{ whiteSpace: 'pre-line' }}>{t('page.caseStudy.cashless.cta.title')}</h2>
          <p className="text-white/80 text-sm sm:text-base leading-relaxed mb-8" style={{ whiteSpace: 'pre-line' }}>{t('page.caseStudy.cashless.cta.body')}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-[#255485] px-8 py-3.5 rounded-lg hover:bg-gray-100 transition-colors duration-200 font-semibold whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              <i className="ri-mail-send-line"></i>{t('page.caseStudy.cashless.cta.button1')}
            </button>
            <Link
              to="/services/cashless"
              className="bg-transparent text-white border-2 border-white/60 px-8 py-3.5 rounded-lg hover:bg-white/10 transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              <i className="ri-arrow-right-line"></i>{t('page.caseStudy.cashless.cta.button2')}
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 mb-12">
            <div>
              <Link to="/" className="flex flex-col leading-none mb-4 cursor-pointer">
                <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.18em' }} className="text-white font-bold text-2xl tracking-widest uppercase">LIKES</span>
                <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.22em' }} className="text-white/70 text-[9px] font-medium tracking-[0.22em] uppercase mt-0.5">Co, Ltd</span>
              </Link>
              <p className="text-white/70 text-sm leading-relaxed" style={{ whiteSpace: 'pre-line' }}>{t('subpage.footer.tagline')}</p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">{t('subpage.footer.nav')}</h3>
              <nav className="space-y-3">
                <Link to="/#vision" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.vision')}</Link>
                <Link to="/#services" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.services')}</Link>
                <Link to="/case-study" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.caseStudy')}</Link>
                <Link to="/#csr" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.csr')}</Link>
                <Link to="/#company" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.company')}</Link>
              </nav>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">{t('subpage.footer.contact')}</h3>
              <p className="text-white/70 text-sm leading-relaxed mb-4">{t('subpage.footer.address')}</p>
              <button onClick={scrollToContact} className="text-white/70 hover:text-white transition-colors duration-200 text-sm underline cursor-pointer">{t('nav.contact')}</button>
            </div>
          </div>
          <div className="border-t border-white/10 pt-8 text-center">
            <p className="text-white/50 text-sm">{t('subpage.footer.copyright')}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
